<template>
  <div class="wrapper">
    <div
      class="ordered-response"
      data-test="ordered-response-question"
    >
      <div class="answer-column">
        <draggable
          v-model="answerColumn"
          v-bind="dragOptions"
          :move="onMove"
          class="full-height"
        >
          <transition-group
            type="transition"
            name="flip-list"
          >
            <div
              v-for="(answer) in answerColumn"
              :key="answer.id"
              class="answer"
            >
              <icon
                class="hamburger-icon"
                name="larger-hamburger"
                variant="7B7B7B"
              />
              {{ answer.text }}
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Icon from '@components/singletons/icon';
import _ from 'lodash';

export default {
  components: {
    draggable,
    Icon,
  },
  props: {
    flashcard: {
      type: Object,
      required: true,
    },
    flashcardState: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answerColumn: [],
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        ghostClass: 'ghost',
      };
    },
    startingAnswerOrder() {
      const pseudoRandom = (id) => {
        const seed = this.flashcard.id || 0;
        const x = Math.sin(seed + id) * 10000;
        return x - Math.floor(x);
      };

      const correctOrder = [...this.flashcard.answers].sort((a, b) => a.correctOrder - b.correctOrder);
      let newOrder = [...this.flashcard.answers].sort((a, b) => a.sortOrder - b.sortOrder);

      if (this.flashcard.randomizedSortOrder) {
        newOrder = [...this.flashcard.answers].sort((a, b) => {
          return pseudoRandom(a.id) - pseudoRandom(b.id);
        });
      }

      if (_.isEqual(newOrder.map((a) => a.id), correctOrder.map((a) => a.id))) {
          return newOrder.reverse();
      }
      return newOrder;
    },
  },
  watch: {
    answerColumn(newValue, oldValue) {
      if (_.isEqual(newValue, oldValue)) {
        return;
      }

      if (_.isEqual(newValue.map((a) => a.id), this.startingAnswerOrder.map((a) => a.id))) {
        this.$emit('set-raw-answer-data', {});
        return;
      }

      this.$emit('set-raw-answer-data', {
        orderedAnswerIds: newValue.map((a) => a.id),
      });
    },
    flashcard() {
      this.setOrderedAnswerList();
    },
  },
  mounted() {
    this.setOrderedAnswerList();
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    setOrderedAnswerList() {
      const orderedAnswerIds = this.flashcardState?.rawAnswerData?.orderedAnswerIds || [];

      if (orderedAnswerIds.length === 0) {
        this.answerColumn = [...this.flashcard.answers].sort((a, b) => a.sortOrder - b.sortOrder);
        return;
      }

      this.answerColumn = orderedAnswerIds.map((id) => {
        return this.flashcard.answers.find((a) => a.id === id);
      }).concat(this.flashcard.answers.filter((a) => !orderedAnswerIds.includes(a.id)));
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: calc(100% - 1.5rem);
}

.ordered-response {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .answer-column {
    width: 100%;
  }

  .answer {
    border: 1px solid #d1d3d4;
    border-radius: 0.25rem;
    padding: 1rem;
    margin: 0.5rem;
    cursor: grab;

    .hamburger-icon {
      margin-right: 0.5rem;
    }
  }

  .sortable-chosen {
    cursor: grabbing;
  }

  .ghost {
    opacity: 0.2;
    background: lightblue;
  }
}

</style>
